export const AIRPORT_DATA_KEY = 'AIRPORT_DATA_KEY';
export const AIRCRAFT_DATA_KEY = 'AIRCRAFT_DATA_KEY';
export const AIRPORT_NAME_KEY = 'airport';
export const AIRCRAFT_NAME_KEY = 'aircraft';
export const ACTIVE_STYLE_KEY = 'ACTIVE_STYLE_KEY';
export const DEFAULT_STYLE_KEY = 'DEFAULT_STYLE_KEY';
export const CLIENT_FORMAT = 'd MMM EEEEEE';
export const SERVER_DATE_FORMAT = 'yyyy.MM.dd';
export const SERVER_TIME_FORMAT = 'HH:mm';
export const FLIGHT_DATETIME_FORMAT = `${SERVER_DATE_FORMAT} ${SERVER_TIME_FORMAT}`;
